import React from 'react';
import './Logo.css';

function Logo() {
    return (
        <div className="platform-logo">
            <img
                src="/Logo.png"
                alt="Platform Logo"
                className="logo-image"
            />
        </div>
    );
}

export default Logo;